<template>
  <div>
    <div class="col-12 klarna-section" v-if="isValidForKlarnaPayment">
            <span class="klarna-content">
              <img src="/ui/design/img/klarna-icon.svg" alt="Klarna icon">
                {{ shouldDisplayKlarnaMessage ? t('klarna.payment.amount.message',
              { params: [{ remainingAmount: calculateRemainingAmount() }] }) : t('klarna.payment.info',
              { params: [{ KlarnaAmount: KlarnaAmount }] }) }}
                <span class="learn-more-klarna" @click="openModal">{{ t('learn.more') }}</span>
            </span>
    </div>

    <klarna-modal v-if="showKlarna" @close="showKlarna = false" />
  </div>
</template>

<script>
import KlarnaModal from './KlarnaModal.vue';

export default {
  components: { KlarnaModal },
  data() {
    return {
      showKlarna: false,
      shippingVisible: false,
      isModalVisible: false,
    };
  },
  // mixins: [productMixin],
  computed: {
    KlarnaAmount() {
      const klarnaAmount = this.productData.final_price / 3;
      return klarnaAmount.toFixed(2);
    },
    shouldDisplayKlarnaMessage() {
      return this.productData.final_price < 100;
    },
    isValidForKlarnaPayment() {
      return this.productData.final_price > 0 && this.productData.final_price <= 1000;
    },
  },
  methods: {
    openModal() {
      this.showKlarna = true;
    }
  },
  closeKlarnaModal() {
    this.showKlarna = false;
  },
  calculateRemainingAmount() {
    const remainingAmount = Math.max(0, 75 - this.productData.final_price);
    return remainingAmount.toFixed(2);
  },
  props: {
    productData: Object
  }
};
</script>

<style>
.klarna-section {
  margin-top: 15px;
  @media screen and (min-width: 1200px) {
    padding-right: 0;
  }
  .klarna-content {
    color: #000000;
    font-size: 12px;
    font-weight: 800;
    .learn-more-klarna {
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
